import {makeStyles} from "@material-ui/core/styles";

export const useUserInfoStyles = makeStyles(() => ({
    infoBoxIcon: {
        color: "black",
        marginRight: "8px"
    }
}));
